/*
 * @Author: YuanYuan
 * @Date: 2023-08-24 18:42:28
 * @LastEditTime: 2024-05-11 15:36:40
 * @description: 判断当前是否为cdnw账号
 */
export const $CDNW = true // window.tenant && window.tenant.toLowerCase() === 'cdnw'
